// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__37hBm","title":"AfterFrontImage_title__3cfEc"};